import React from 'react';
import { Zap, Minus, TrendingDown } from 'lucide-react';

type LeverageLevel = 'High' | 'Medium' | 'Low';

interface LeverageBadgeProps {
  level: LeverageLevel;
  showIcon?: boolean;
  size?: 'sm' | 'md';
}

export default function LeverageBadge({ level, showIcon = true, size = 'md' }: LeverageBadgeProps) {
  const config = {
    High: {
      className: 'bg-amber-500/15 text-amber-400 border border-amber-500/30',
      icon: <Zap size={size === 'sm' ? 10 : 12} className="fill-amber-400" />,
    },
    Medium: {
      className: 'bg-blue-500/15 text-blue-400 border border-blue-500/30',
      icon: <Minus size={size === 'sm' ? 10 : 12} />,
    },
    Low: {
      className: 'bg-zinc-700/40 text-zinc-400 border border-zinc-700/50',
      icon: <TrendingDown size={size === 'sm' ? 10 : 12} />,
    },
  };

  const { className, icon } = config[level];
  const textSize = size === 'sm' ? 'text-[10px]' : 'text-xs';
  const padding = size === 'sm' ? 'px-2 py-0.5' : 'px-2.5 py-1';

  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-600 ${className} ${textSize} ${padding}`}>
      {showIcon && icon}
      {level}
    </span>
  );
}